import AddToTeamIcon from './AddToTeamIcon';

export default AddToTeamIcon;
